import { render } from "./secondary-chart.vue?vue&type=template&id=46dcad29"
import script from "./secondary-chart.vue?vue&type=script&lang=js"
export * from "./secondary-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__